import { FullscreenSpinner } from '@frontend/components/common';

import AcceptEula from './accept-eula/accept-eula.component';
import useAuthentication from './authentication.controller';
import BasicLogin from './basic-login/basic-login.component';

export const ID = 'authentication';
export interface Props {
    children: React.ReactNode;
}

const Authentication = (props: Props) => {
    const viewProps = useAuthentication();
    let content = (
        <FullscreenSpinner
            screenClassName='bg-background-surface'
            spinner={{ className: 'text-brand-light fill-brand-primary size-16' }}
        />
    );

    if (!viewProps.authenticated) content = <BasicLogin callback={viewProps.onLoginSucceeded} />;
    else if (!viewProps.user)
        content = (
            <FullscreenSpinner
                screenClassName='bg-background-surface'
                spinner={{ className: 'text-brand-light fill-brand-primary size-16' }}
            />
        );
    else if (viewProps.shouldAcceptEula)
        content = (
            <AcceptEula
                user={viewProps.user}
                callback={viewProps.acceptEulaCallback}
                overrideUrl={viewProps.overrideEulaUrl}
            />
        );
    else content = props.children as React.ReactElement;

    return (
        <div
            id={ID}
            className='h-full overflow-hidden'>
            {content}
        </div>
    );
};

export default Authentication;
